module.exports = __webpack_public_path__ + "static/chirpyest-logo-front-50e5c3a0e0e9f56ebfa0f393b170bd93.svg";